<div class="search-criteria-panel">
  <div class="skiplink">
    <a href="#search-content">Skip to content</a>
  </div>
  <div class="search-criteria-panel-contents">
    <div class="search-bar">
      <ng-content select="app-search-bar"></ng-content>
    </div>
    <div class="sidebar-content">
      <ng-content select="[sidebar]"></ng-content>
    </div>
  </div>
</div>

<div class="search-content">
  <a id="search-content"></a>
  <ng-content></ng-content>
</div>
